<template>
  <div>
    <el-container>
      <el-header>
        <outsidetop></outsidetop>
        <div class="bgfff" style="padding:16px 0;background:#f5f5f5;display:block">
          <div class="w1200" style="margin:0 auto">
            <el-row>
              <el-col :span="10">
                <div class="hotBox">
                  <span class="hotSpan">户外露营装备畅销全球</span>
                </div>
              </el-col>
              <el-col :span="10">
                <div class="searchBox">
                  <el-autocomplete v-model="searchInput" @change="getSearchClick(searchInput)" @select="searcheSelect" :fetch-suggestions="querySearchAsync" placeholder="商品关键字/SKU/货号" class="input-with-select" style="border: 4px solid #EA0A2A;width:100%;height:36px;background-color: #fff;">
                    <el-button slot="append" icon="el-icon-search" style="font-size: 22px; z-index:60;" id="seekBtn" @click="getSearchClick(searchInput)"></el-button>
                  </el-autocomplete>
                  <div style="margin-top: 5px; text-align: left" v-if="hotSearchList.length>0">
                    <span v-for="(item, index) in hotSearchList" :key="index">
                      <span class="keyWords" @click="getSearchClick(item)">{{item}}</span>
                      <el-divider v-if="index!=hotSearchList.length-1" direction="vertical"></el-divider>
                    </span>
                  </div>
                </div>
              </el-col>
              <el-col :span="4" style="text-align: right" v-if="userInfo.userId&&userInfo.userId!=10853">
                <div class="grid-content bg-purple">
                  <el-button :class="list.length>0 ? 'shopgoods' : 'btnBg'" @click="openDrawer">
                    <i class="el-icon-shopping-cart-full"></i>&ensp;购物车&ensp;({{ totalNumber }})
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <!-- 顶部菜单 -->
        <div class="w w1200" v-if="isShowNav" style="display:block">
          <div class="categorys">
            <div class="categorys-type" @mouseenter="mouseenterBox" @mouseleave="mouseLeaveBox">
              <!-- 全部商品分类 -->
              <a href="javascript:;" name="153">
                <i class="el-icon-menu"></i>&ensp;全部商品分类</a>
            </div>
            <!-- 隐藏分类 -->
            <div class="categorys-tab-content" v-show='isShowCategoryList' @mouseenter="mouseSecondEnterBox" @mouseleave="mouseSecondLeveBox">
              <div class="categorys-items" id="cata-nav">
                <!-- 商品分类start -->
                <div class="categorys-item" v-for="(oneItem, index) in categoryList" :key="index + '_item'">
                  <div class="item item-content" @click="$router.push(`/goodsList?page=home&parentBxscId=${oneItem.categoryOne.parentBxscId}&bxscId=${oneItem.categoryOne.bxscId}&level=1`)">
                    <img :src="oneItem.categoryOne.icon" style="vertical-align:baseline;width:22px;height:22px;" />
                    <div class="categorys-title">
                      <!-- 左侧一级分类 -->
                      <strong>
                        <a href="javascript:void(0)">{{ oneItem.categoryOne.name }}</a>
                      </strong>
                    </div>
                  </div>
                  <div class="categorys-items-layer categorys-items-second-layer">
                    <div class="cate-layer-con clearfix">
                      <!-- 右侧 -->
                      <div class="cate-layer-left">
                        <div class="cate_channel">
                          <!-- 右侧二级分类 -->
                          <router-link :to="`/goodsList?page=home&parentBxscId=${subItem.category.parentBxscId}&bxscId=${subItem.category.bxscId}&level=2`" v-for="(subItem, index) in oneItem.subItems.slice(0,7)" :key="index + 'sunItem'">{{ subItem.category.name }}</router-link>
                          <span class="moreSpan" @click="$router.push(`/goodsList?page=home&parentBxscId=${oneItem.categoryOne.parentBxscId}&bxscId=${oneItem.categoryOne.bxscId}&level=1`)" v-if="oneItem.subItems.length>7">
                            查看更多>>
                          </span>
                        </div>
                        <div class="cate_detail">
                          <dl v-for="(subItem, index) in oneItem.subItems.slice(0,7)" :key="index + 'sunItem'" :class="'dl_fore' + (index + 1)">
                            <!-- 右侧-左边二级分类 -->
                            <dt>
                              <router-link :to="`/goodsList?page=home&parentBxscId=${subItem.category.parentBxscId}&bxscId=${subItem.category.bxscId}&level=2`">{{ subItem.category.name }}</router-link>
                            </dt>
                            <dd>
                              <!-- 右侧-三级分类 -->
                              <router-link :to="`/goodsList?page=home&parentBxscId=${thrItem.parentBxscId}&bxscId=${thrItem.bxscId}&level=3`" v-for="(thrItem, index) in subItem.sub" :key="index + '_thr'">{{ thrItem.name }}</router-link>
                            </dd>
                          </dl>
                          <dl class="moreDl" v-if="oneItem.subItems.length>7">
                            <div class="moreClass" @click="$router.push(`/goodsList?page=home&parentBxscId=${oneItem.categoryOne.parentBxscId}&bxscId=${oneItem.categoryOne.bxscId}&level=1`)">更多分类>></div>
                          </dl>
                        </div>
                      </div>
                      <div v-if="oneItem.subItems.length == 0 ? true : false" class="nodataCss">
                        <p>{{$t('index.No related classification data')}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="clear"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="nav-main">
            <!-- 首页-所有产品-新品 -->
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" router @select="handleSelect">
              <template v-for="(item, index) in navList">
                <el-menu-item :index="item.navUrl" :key="index">
                  <i>{{ item.navTitle }}</i>
                </el-menu-item>
              </template>
            </el-menu>
          </div>
        </div>
      </el-header>

      <el-main>
        <!-- 主要内容 -->
        <router-view v-if="routerAlive"></router-view>
      </el-main>

      <el-footer>
        <footernav></footernav>
      </el-footer>
    </el-container>

    <div class="fixedRightNav" style="display:none">
      <!-- 右侧悬浮框 -->
      <div class="rightNav">
        <!-- <p class="el-icon-user"></p> -->
        <transition name="el-fade-in-linear">
          <el-popover placement="left-end" width="300" trigger="click">
            <div>
              <el-row :gutter="20" class="userNameBox">
                <el-col :span="9">
                  <el-image style="cursor:pointer" class="userNameImg" :src="userInfo.avatar" fit="fill">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </el-col>
                <el-col :span="14" class="userNameBoxText">
                  <p class="userName">{{$t('car.user')}}：{{userInfo.userName}}</p>
                  <!-- <p class="level">{{$t('car.grade')}}：{{userInfo.level||0}}</p> -->
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <el-row class="cartBox_footer">
                <el-col :span="12" class="userNameBoxBottom">
                  <router-link to="/myInfomation">个人中心</router-link>
                </el-col>
                <el-col :span="12" class="userNameBoxBottom">
                  <router-link to="/myOrderRight">订单中心</router-link>
                </el-col>
              </el-row>
            </div>
            <el-button slot="reference">
              <p class="el-icon-user"></p>
            </el-button>
          </el-popover>
        </transition>
        <div @click="openCartDrawer" class="shoppingCart">
          <i class="el-icon-shopping-cart-2"></i>
          <p>{{$t('car.shopping cart')}}</p>
          <div class="cartNum">
            <span>{{totalNumber >99?'99+':totalNumber}}</span>
          </div>
        </div>
        <!-- <div class="el-icon-view" @click="openFooterDrawer"></div> -->

        <transition name="el-fade-in-linear">
          <el-popover popper-class="nolikePopBox" placement="left-end" width="50" trigger="hover">
            <div class="userPartPop">
              {{$t('car.i have seen')}}
            </div>
            <el-button slot="reference">
              <div class="el-icon-view" @click="openFooterDrawer"></div>
            </el-button>
          </el-popover>
        </transition>

        <transition name="el-fade-in-linear">
          <el-popover popper-class="nolikePopBox" placement="left-end" width="50" trigger="hover">
            <div class="userPartPop">
              {{$t('car.my favorites')}}
            </div>
            <el-button slot="reference">
              <div class="nolike" @click="$router.push('/goodsCollection')">
                <img :src="require('@/assets/img/noLIke.png')" alt="">
              </div>
            </el-button>
          </el-popover>
        </transition>

        <transition name="el-fade-in-linear">
          <el-popover popper-class="userPartPopBox" placement="left-end" width="100" trigger="hover">
            <div class="userPartPop userPart" style="cursor:pointer" @click="centerDialogVisible = true" title="点击我，打开聊天窗口">
              <!-- <el-image class="userPartPop_img" style="cursor:pointer" :src="userInfo.avatar" fit="fill" @click="centerDialogVisible = true">
                              <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                              </div>
                        </el-image> -->
              <el-image class="userPartPop_img" :src="`${(userInfo.avatar!=undefined || userInfo.avatar!=null|| userInfo.avatar!='') ?userInfo.avatar:''}`" fit="fill">
                <div slot="error" class="image-slot bg-font-size-big">
                  <i class="el-icon-user"></i>
                </div>
              </el-image>
              <div class="userPartPop_text">
                {{this.userInfo.userName}}
              </div>
            </div>
            <el-button slot="reference" class="userPart">
              <div style="width:100%">
                <!-- <el-image style="cursor:pointer" :src="userInfo.avatar" fit="fill">
                              <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                              </div>
                        </el-image> -->
                <el-image class="userPartPop_img" style="cursor:pointer" :src="`${(userInfo.avatar!=undefined || userInfo.avatar!=null || userInfo.avatar!='') ?userInfo.avatar:''}`" fit="fill">
                  <div slot="error" class="image-slot bg-font-size-big">
                    <i class="el-icon-user"></i>
                  </div>
                </el-image>
              </div>
            </el-button>
          </el-popover>
        </transition>
        <transition name="el-fade-in-linear">
          <el-popover popper-class="backTopBox" placement="left-end" width="100" trigger="hover">
            <div class="userPartPop">
              {{$t('car.back to the top')}}
            </div>
            <el-button slot="reference" class="">
              <div>
                <el-backtop :right=0 :bottom=0>
                  <i class="el-icon-upload2"></i>
                </el-backtop>
              </div>
            </el-button>
          </el-popover>
        </transition>
        <!-- <div class="userPart">
               <el-image style="cursor:pointer" :src="require('@/assets/img/user.png')" fit="fill">
                     <div slot="error" class="image-slot">
                       <i class="el-icon-picture-outline"></i>
                     </div>
               </el-image>
            </div> -->
      </div>
      <!-- 购物车 开始 -->
      <el-drawer class="myShopCar" title="我的购物车" :modal="true" size="480px" :append-to-body="true" :visible.sync="shopcarDrawer">
        <div class="shopcarEle" v-if="list.length>0" v-loading="$store.state.airLoading">
          <div class="priceTab">
            <div :class="['tabDiv',$store.state.shoppingCarNum==1?'activted':'']" @click="cliActivted(1)">代发</div>
            <div :class="['tabDiv',$store.state.shoppingCarNum==2?'activted':'']" @click="cliActivted(2)">经销</div>
          </div>
          <div class="goodsBox">
            <el-row v-for="(item,index) in list" :key="index" :gutter="16" style="padding-bottom:8px;">
              <el-col :span="4">
                <div class="goodsPhotos">
                  <img v-lazy="item.photos" alt="" style="cursor:pointer;height:61px;width:61px;" @click="jumpUrl(item)">
                  <!-- cartStatus：1-库存不足，2-无效 ，0-正常-->
                  <div class="maskEle" v-if="item.cartStatus=='1'" @click="jumpUrl(item)">
                    <p>库&ensp;存</p>
                    <p>不&ensp;足</p>
                  </div>
                  <div class="maskEle" style="color:#EA0A2A;cursor:default;" v-if="item.cartStatus=='2'">
                    <p>无&ensp;效</p>
                    <p>商&ensp;品</p>
                  </div>
                </div>
              </el-col>
              <el-col :span="14">
                <p class="overflowEllipsis">{{item.name}}</p>
                <p style="color:#ff6700" v-if="item.cartSpecificationDetails">
                  {{item.cartSpecificationDetails ? item.cartSpecificationDetails.code : ''}}
                </p>
                <p style="color:#ff6700">
                  {{item.cartSpecificationDetails ? item.cartSpecificationDetails.attributeContent : '默认规格'}}
                  <el-tag effect="dark" type="warning" size="mini" v-if="item.cartSpecificationDetails&&item.cartSpecificationDetails.clearTag">{{item.cartSpecificationDetails.clearTag}} </el-tag>
                </p>
              </el-col>
              <el-col :span="6">
                <span style="color:#ff6700">{{item.member_price?item.member_price:0}} * {{item.number}}</span>
              </el-col>
            </el-row>
          </div>
          <div class="settleBox">
            <div class="priceNum">
              <p class="num">共&ensp;{{totalNumber||0}}&ensp;件商品</p>
              <p class="price">总计&ensp;{{accountTotal.toFixed(2) || 0}}&ensp;元</p>
            </div>
            <div class="cartHeight_cart" @click="jumpCar">
              <a href="javascript:void(0)" style="color:white">去购物车结算</a>
            </div>
          </div>
        </div>
        <div class="nogoods" v-if="list.length==0 ? true:false">
          <el-image :src="require('@/assets/img/noresult.png')" fit="fill">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <p @click="jumpGoods">购物车空空如也，来挑几件好货吧！</p>
          <p style="color:#ff6700;margin-top:0px;cursor: pointer;letter-spacing:1px;">
            <span @click="jumpGoods(1)">挑选宝贝</span>&ensp;|&ensp;
            <span @click="jumpGoods(2)">我的购物车</span>
          </p>
        </div>
      </el-drawer>
      <!-- 购物车 结束 -->

      <!-- 我的足迹 开始-->
      <el-drawer class="drawerCart" :title="$t('car.shopping cart')" :modal="false" :visible.sync="footerdrawer">
        <p class="drawerCartTitle" slot="title">
          <i class="el-icon-view"></i>
          <router-link class="gotoShopText" to="/myFooter">{{$t('car.my footprint')}}</router-link>
        </p>
        <div class="drawerCartItem drawerFooterItem" v-loading="footloading">
          <div class="isdrawerFooterItem" v-for="(item,index) in footerlist" :key="index">
            <div class="isdrawerFooterItemBg" v-if="item.commodity!=null">
              <el-image class="goodsFooter" style="cursor:pointer" @click="$router.push(`/goodsdetail?id=${item.commodity.id}`)" :src="`${item.commodity.photos}`" fit="fill">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <div class="cartHeight">￥{{item.commodity.member_price}}</div>
            </div>
          </div>

          <!-- 购物车没有东西的时候 -->
          <div class="drawerCartItem_no" v-if="footerlist.length==0?true:false">
            <el-image style="cursor:pointer" :src="require('@/assets/img/noresult.png')" fit="fill">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <p>{{$t('car.No history of your browsing')}}</p>
            <router-link class="gotoShopText" to="/goodsList?page=newFlag">{{$t('car.go see it again')}}</router-link>
          </div>
        </div>
      </el-drawer>
      <!-- 我的足迹 结束-->
    </div>
    <!-- IM -->
    <el-dialog class="dialogIMBox" title="提示" :visible.sync="centerDialogVisible" :modal="b_modal" width="35%" :append-to-body="bodyflag" center>
      <span slot="title" class="dialog-footer">
      </span>
      <div class="row1" id="content-main-1">
        <iframe id="myiframe" onload="setIframeHeight(this)" src='http://122.51.226.11/IM/#/main' width="100%" height="100%" frameborder="0" seamless scrolling="no"></iframe>
      </div>
    </el-dialog>
    <!-- <div style="height:16px;background:#fff!important"></div> -->
  </div>
</template>


<script>
// 导入组件
import "../../static/im/js/configIM.js";
import { menu } from "../api/userMG";
import footernav from "../components/footernav.vue";
import outsidetop from "../components/outsideTop.vue";
import mainlayout from "../components/layout/mainlayout";
import lang from "@/components/lang";
import {
  footprint_list,
  navList,
  leftMenuList,
  shoppingCartlist,
  hot_search,
  search_list,
  setImage,
  systemConfig,
  apiConfig,
  apiHelpArticle,
  searchCompletion,
  repair
} from "@/api/xunyou";
import { mapState, mapMutations } from "vuex";
import QRCode from "qrcodejs2";
import bus from "@/utils/bus"; //引入事件中心
export default {
  name: "index",
  provide() {
    //在父组件中创建属性
    return {
      routerRefresh: this.routerRefresh
    };
  },
  inject: ["reload"],
  // 注册组件
  components: {
    footernav,
    outsidetop,
    mainlayout,
    lang
  },
  computed: {
    ...mapState([
      "isShowNav",
      "list",
      "accountTotal",
      "totalNumber",
      "copyRight"
    ])
  },
  data() {
    let self = this;
    return {
      visible: false,
      hotSearchList: [],
      searchInput: "",
      routerAlive: true,
      bodyflag: true,
      b_modal: false,
      footloading: false,
      footerdrawer: false,
      footerlist: [],
      showclass: "asideshow",
      showtype: false,
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      appimg:
        "https://ceshi.xunyoutest.com/image.php/shop/data/upload/media/plantform/image/20200806/1596701627449534.png",
      showwx: false, //微信不显示
      show2: false, //默认进入不显示
      collapsed: false,
      allmenu: [],
      drawer: false,
      shopcarDrawer: false,
      loading: false,
      showapp: false, //app不显示
      // accountTotal:0,
      // list:[],
      centerDialogVisible: false,
      isShowCategoryList: false,
      timer: null,
      categoryList: [],
      showThreeClass: false, // 是否展示三级分类
      activeIndex: "",
      navList: [],
      //地图
      center: [121.59996, 31.197646],
      city: this.$t("index.merchant shop"),
      lng: 0,
      lat: 0,
      loaded: false,
      logo: "",
      // plugin: [
      //   {
      //     pName: "Geolocation",
      //     events: {
      //       init(o) {
      //         // o 是高德地图定位插件实例
      //         o.getCurrentPosition((status, result) => {
      //           if (result && result.position) {
      //             self.$store.commit(
      //               "gotCurrentAddress",
      //               result.addressComponent
      //             );
      //             console.log(result, "|wb");
      //             self.lng = result.position.lng;
      //             self.lat = result.position.lat;
      //             self.city =
      //               result.addressComponent.city ||
      //               result.addressComponent.district;
      //             self.center = [self.lng, self.lat];
      //             self.loaded = true;
      //             self.$nextTick();
      //           }
      //         });
      //       },
      //     },
      //   },
      // ],
      appUrl: "",
      helpArticle: [],
      showAppCode: false,
      showRegister: true
    };
  },
  // watch:{
  //     $route:{
  //       handler(to,from){
  //           console.log(to,from,"路由--");
  //       },
  //       deep:true
  //     }
  // },
  created() {
    this.getRepair();
    // this.getshoppingCartlist();
    //导航列表
    if (this.$store.state.navList.length > 0) {
      this.navList = this.$store.state.navList;
    } else {
      this.searchNavList();
    }
    //全部商品分类
    if (this.$store.state.categoryList.length > 0) {
      this.categoryList = this.$store.state.categoryList;
    } else {
      this.searchleftMenuList();
    }
    var routeQuery = this.$route.query;
    if (routeQuery.page == "home") {
      //所有产品
      this.activeIndex = "/goodsList?page=home";
    } else if (routeQuery.page == "newFlag") {
      //新品
      this.activeIndex = "/goodsList?page=newFlag";
    } else if (routeQuery.page == "hot") {
      //热销
      this.activeIndex = "/goodsList?page=hot";
    } else if (routeQuery.page == "clear") {
      //清仓
      this.activeIndex = "/goodsList?page=clear";
    } else if (this.$route.path == "/goodsList") {
      //默认新品
      this.activeIndex = "/goodsList?page=newFlag";
    } else {
      this.activeIndex = "-1";
    }
    //热门搜素关键字
    if (this.$store.state.hotSearchList.length > 0) {
      this.hotSearchList = this.$store.state.hotSearchList;
    } else {
      this.gethotSearch();
    }
    // 监听
    this.$root.Bus.$on("toggle", value => {
      if (value) {
        this.showclass = "asideshow";
      } else {
        setTimeout(() => {
          this.showclass = "aside";
        }, 300);
      }
    });
  },
  mounted() {
    this.cityData = JSON.parse(localStorage.getItem("cityInfo"));
    if (this.cityData) {
      this.city = this.cityData.cname;
    }
    if (this.city) {
      this.loaded = true;
    }
    // this.getfootList()  //查询我的足迹
    // this.IMUtil.init();
    // this.getImagelogo();
    // this.getTopApiConfig('appDownload')
    // this.getTopApiConfig('merchantSettled')
  },
  methods: {
    cliActivted(val) {
      this.$store.commit("setShoppingCarNum", val);
      this.$store.dispatch("getshoppingCartlist");
      // this.getshoppingCartlist();
    },
    getRepair() {
      repair()
        .then(res => {
          if (res.code == "0") {
            if (res.data.repairFlag) {
              // 维护中..
              localStorage.clear();
              sessionStorage.clear();
              //清空购物车
              this.$store.state.totalNumber = 0;
              this.$store.state.list = [];
              // this.$router.replace({ path: '/maintaining' });
              this.$store.commit("setgrayscale", false);
            } else {
              let arrArr = res.data.grayBoxTestUserList.split(",");
              if (arrArr.length > 0) {
                if (arrArr.includes("1")) {
                  // 全开
                  this.$store.commit("setgrayscale", true);
                } else if (arrArr.includes("-1")) {
                  //     // 全关
                  this.$store.commit("setgrayscale", false);
                } else {
                  if (this.userInfo.userId) {
                    var str = this.userInfo.userId + "";
                    if (arrArr.includes(str)) {
                      // 存在
                      this.$store.commit("setgrayscale", true);
                    } else {
                      this.$store.commit("setgrayscale", false);
                    }
                  } else {
                    // 没登录
                    this.$store.commit("setgrayscale", false);
                  }
                }
              }
              console.log(this.$store.state.grayscale, "grayscale");
            }
          } else {
            localStorage.clear();
            sessionStorage.clear();
            //清空购物车
            this.$store.state.totalNumber = 0;
            this.$store.state.list = [];
            // this.$router.replace({ path: '/maintaining' });
            this.$store.commit("setgrayscale", false);
          }
        })
        .catch(err => {
          this.$store.commit("setgrayscale", false);
          localStorage.clear();
          sessionStorage.clear();
          this.$store.state.totalNumber = 0;
          this.$store.state.list = [];
          this.$router.replace({ path: "/maintaining" });
        });
    },
    jumpGoods(val) {
      this.shopcarDrawer = false;
      if (val == "1") {
        this.$router.push("/goodsList?page=newFlag");
      } else if (val == "2") {
        this.$router.push("/shoppingcart");
      }
    },
    openDrawer() {
      this.shopcarDrawer = true;
    },
    jumpUrl(item) {
      let routeData = this.$router.resolve(`/goodsdetail?id=${item.id}`);
      window.open(routeData.href, "_blank");
    },
    jumpCar() {
      this.$router.push({ path: "/shoppingcart" });
      this.shopcarDrawer = false;
      // setTimeout(() => {
      //   this.$refs.poup.doClose()
      // }, 0)
    },
    // closePoup() {
    //   this.$refs.poup.doClose()
    // },
    //全部商品分类
    searchleftMenuList() {
      leftMenuList()
        .then(res => {
          if (res.code == 0) {
            this.categoryList = res.data;
          } else {
            this.$message({
              type: "info",
              message: res.msg
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 菜单
    searchNavList() {
      navList()
        .then(res => {
          if (res.code == 0) {
            this.navList = res.data;
          } else {
            console.log(res.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 系统参数 == 客户服务
    getApiHelpArticle() {
      apiHelpArticle().then(res => {
        if (res.code == 0) {
          if (res.data.length > 0) {
            this.helpArticle = res.data || [];
          }
        }
      });
    },
    // 获取系统参数 == 是否展示商家入口/是否app二维码下载
    getTopApiConfig(key) {
      apiConfig({
        key: key,
        accountingCompanyCode: this.userInfo.accountingCompanyCode || ""
      }).then(res => {
        // console.log(res,"res----");
        if (res.code == 0) {
          if (res.rows.length > 0) {
            if (key == "merchantSettled") {
              this.showRegister = res.rows[0].configValue == 1 ? true : false; // 1开，2关
            } else {
              this.showAppCode = res.rows[0].configValue == 1 ? true : false; // 1开，2关
            }
          }
        }
      });
    },
    // 获取系统参数 == 是否展示三级分类
    getApiConfig() {
      // console.log("11111111----");
      apiConfig({
        key: "show_three_class",
        accountingCompanyCode: this.userInfo.accountingCompanyCode || ""
      }).then(res => {
        // console.log(res,"----");
        if (res.code == 0) {
          if (res.rows.length > 0) {
            // console.log(res,"res.rows----");
            this.showThreeClass = res.rows[0].configValue == 1 ? true : false; // 1开，2关
          }
        }
      });
    },
    // 获取购物车
    // getshoppingCartlist() {
    //   this.shoppingCarLoading=true;
    //   let agencyAddressFlag=false;  //代发
    //   if(this.$store.state.shoppingCarNum=='2'){
    //     agencyAddressFlag=true;
    //   }
    //   shoppingCartlist({
    //     uid: this.userInfo.userId || "",
    //     userToken: this.userInfo.userToken || "",
    //     agencyAddressFlag
    //   }).then((res) => {
    //     this.shoppingCarLoading=false;
    //     if (res.code == '0') {
    //       this.$store.commit("getCartList", res.data);
    //     } else {
    //       if (res.code == "2001") {
    //         localStorage.removeItem("userdata");
    //         this.$router.push("/login")
    //       }
    //       this.$message({
    //         message: res.msg,
    //         type: 'warning',
    //         duration: 2000
    //       });
    //     }
    //   }).catch((err) => {
    //       this.shoppingCarLoading=false;
    //       console.log(err);
    //     });
    // },
    // 获取logo
    getImagelogo() {
      setImage().then(res => {
        if (res.code == 0) {
          this.logo = res.rows[0].pcLogo;
        }
      });
    },
    // 热门搜索
    gethotSearch() {
      hot_search()
        .then(res => {
          if (res.code == 0) {
            this.hotSearchList = res.data.column10.split(",");
          } else {
            this.$message({
              type: "info",
              message: res.msg
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // app下载 ==== app
    creatQrCode() {
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: this.appUrl, // 需要转换为二维码的内容
        width: 100,
        height: 100,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      });
    },
    // 获取系统参数
    getSystemConfig() {
      systemConfig().then(res => {
        if (res.code == 0) {
          // console.log(res,"res---");

          res.rows.forEach(element => {
            if (element.configKey == "appUrl") {
              this.appUrl = element.configValue;
            }
            if (element.configKey == "H5Url") {
              this.H5Url = element.configValue;
            }
          });
          // this.creatQrCode();
          // this.creatH5QrCode()
        }
      });
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    mouseSecondLeveBox() {
      this.isShowCategoryList = false;
      clearTimeout(this.timer);
      this.timer = null;
    },
    mouseSecondEnterBox() {
      this.isShowCategoryList = true;
    },
    routeToHome() {
      this.$router.push("/");
    },
    // 鼠标移入移出
    mouseLeaveBox() {
      if (this.$route.path == "/" || true) {
        this.isShowCategoryList = false;
        // console.log(this.timer);
        clearTimeout(this.timer);
        this.timer = null;
      } else {
        this.isShowCategoryList = false;
      }
    },
    // 鼠标移入移出
    mouseenterBox() {
      if (this.$route.path == "/" || true) {
        // this.isShowCategoryList = !this.isShowCategoryList;
        // console.log('init', this.timer);
        if (this.timer) {
          return;
        } else {
          this.timer = setTimeout(() => {
            this.isShowCategoryList = true;
            clearTimeout(this.timer);
            this.timer = null;
          }, 200);
        }
      } else {
        this.isShowCategoryList = false;
      }
    },
    getSearchClick(name) {
      this.$router.push({
        path: "/goodsList",
        query: {
          page: "home",
          parentBxscId: "",
          bxscId: "",
          level: "",
          adWord: name
        }
      });
      // let path = this.$route.path;
      // let val = ''
      // if (name) {
      //   val = name
      //   this.searchInput = name
      // } else {
      //   val = this.searchInput == "" ? this.hotSearchList[0] : this.searchInput;
      // }
      // if (!this.searchInput) {
      //   this.searchInput = this.hotSearchList[0];
      // }
      // // if (path !== "/goodsList") {
      // if (path.includes('supplier')) {
      //   this.$router.push(`/goodsList_supplier?adWord=${val}`);
      // } else {
      //   if (path != "/goodsList") {
      //     this.$router.push(`/goodsList?adWord=${val}`);
      //     return
      //   } else {
      //     let query = JSON.parse(JSON.stringify(this.$route.query));
      //     query.adWord = val;
      //     this.$router.replace({
      //       query,
      //     });
      //     bus.$emit("search", val);
      //   }
      // }
    },
    async querySearchAsync(queryString, cb) {
      // console.log(queryString)
      // console.log(cb)
      let params = {
        searchStr: this.searchInput
      };
      let res = await searchCompletion(params);
      var restaurants = res.rows.map(res => {
        return {
          value: res.name,
          address: res.id
        };
      });
      var results = restaurants;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 3000 * Math.random());
    },
    searcheSelect(item) {
      // console.log(item, "item----");
      this.$router.push({
        path: "/goodsList",
        query: {
          page: "home",
          parentBxscId: "",
          bxscId: "",
          level: "",
          adWord: item.value
        }
      });

      // let name = item.value
      // let path = this.$route.path;
      // let val = ''
      // if (name) {
      //   val = name
      //   this.searchInput = name
      // } else {
      //   val = this.searchInput == "" ? this.hotSearchList[0] : this.searchInput;
      // }
      // if (!this.searchInput) {
      //   this.searchInput = this.hotSearchList[0];
      // }
      // // if (path !== "/goodsList") {
      // if (path.includes('supplier')) {
      //   this.$router.push(`/goodsList_supplier?adWord=${val}`);
      // } else {
      //   if (path != "/goodsList") {
      //     this.$router.push(`/goodsList?adWord=${val}`);
      //     return
      //   } else {
      //     let query = JSON.parse(JSON.stringify(this.$route.query));
      //     query.adWord = val;
      //     this.$router.replace({
      //       query,
      //     });
      //     bus.$emit("search", val);
      //   }
      // }
    },
    routerRefresh() {
      this.routerAlive = false;
      this.$nextTick(() => {
        this.routerAlive = true;
      });
    },
    // // 购物车查询
    // getshoppingCartlist() {
    //   this.accountTotal =0
    //    this.loading = true
    //   shoppingCartlist({uid:this.userInfo.userId||''})
    //     .then((res) => {
    //      if(res.length>0){
    //         this.loading = false
    //      let newList= []
    //       res.forEach((x)=>{
    //           x.bxunyouMerchant.goods.forEach((y)=>{
    //             newList.push(y)
    //           })
    //       })
    //         this.list = newList;
    //         let sum = this.list.reduce((sum, item) => {
    //                   return sum + item.realprice * item.number; // 隐式转换
    //               }, 0);
    //               this.accountTotal += sum;
    //      }
    //         })
    //     .catch((err) => {
    //       // this.$message.error("查询购物车失败，请稍后再试！");
    //     });
    // },

    // 打开侧边的购物车
    openCartDrawer() {
      if (this.userInfo.userId == undefined) {
        this.$message.error(this.$t("car.please sign in!"));
        setTimeout(() => {
          this.$router.push("/login");
        }, 2000);
        return;
      }
      this.drawer = true;
      console.log("ji你来了吗", this.drawer);
      this.footerdrawer = false;
      // this.getshoppingCartlist()
    },

    // 查询我的足迹
    getfootList() {
      this.loading = true;
      footprint_list({ uid: this.userInfo.userId })
        .then(res => {
          if (res.code == 0) {
            this.loading = false;
            this.footerlist = res.rows;
          } else {
            this.$message({
              type: "info",
              message: res.msg
            });
          }
        })
        .catch(err => {
          this.loading = false;
          // this.$message.error(this.$t('car.My track lookup failed, please try again later!'));
          console.log(err);
        });
    },
    // 打开侧边的我的足迹
    openFooterDrawer() {
      this.footerdrawer = true;
      this.drawer = false;
      // this.footerlist = this.list
      this.getfootList();
    }
    // handleClose(done) {
    //     this.$confirm('确认关闭？')
    //       .then(_ => {
    //         done();
    //       })
    //       .catch(_ => {});
    //   }
  }
};
</script>
<style lang="less" scoped>
.priceTab {
  display: flex;
  margin-bottom: 12px;
  .tabDiv {
    height: 50px;
    line-height: 50px;
    flex: 1;
    font-size: 16px;
    text-align: center;
    cursor: pointer;
    background: #f5f5f5;
    &:first-child {
      border-right: 1px solid #fff;
    }
    &.activted {
      background: #ff6700;
      color: #fff;
      font-weight: bold;
    }
  }
}
.keyWords {
  color: #333;
  &:hover {
    cursor: pointer;
    color: #f56c6c;
  }
}
.goodsPhotos {
  width: 61px;
  height: 61px;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  .maskEle {
    width: 100%;
    height: 100%;
    background: rgba(242, 244, 251, 0.6);
    color: rgba(6, 6, 6, 0.6);
    font-weight: bold;
    position: absolute;
    font-size: 16px;
    z-index: 5;
    top: 0px;
    left: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    p {
      line-height: normal;
    }
  }
}

.cate-layer-left {
  width: 860px;
  cursor: default;
  .cate_channel {
    overflow: visible;
    .moreSpan {
      float: left;
      margin-right: 10px;
      padding: 0px 10px 0 12px;
      height: 24px;
      line-height: 24px;
      color: #fff;
      background-color: #f42424;
      cursor: pointer;
    }
  }
  .moreDl {
    text-align: center;
    padding: 12px 0;
    .moreClass {
      cursor: pointer;
      color: #fff;
      background-color: #f42424;
      font-size: 13px;
      display: inline-block;
      padding: 6px 20px;
    }
  }
}

.myShopCar {
  /deep/ .el-drawer__header {
    margin-bottom: 16px;
    span {
      font-size: 18px;
      color: #333;
    }
  }
  .nogoods {
    text-align: center;
    p {
      font-size: 16px;
      margin-top: 20px;
    }
  }
  .shopcarEle {
    padding: 0px 16px 16px 16px;
    box-sizing: border-box;
    padding-bottom: 70px;
    position: relative;
    height: calc(100vh - 90px);
    .goodsBox {
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;
      .el-row {
        margin-bottom: 8px;
        border-bottom: 1px solid #d8d8d8;
      }
    }
    .settleBox {
      height: 60px;
      position: absolute;
      bottom: 0px;
      left: 0px;
      width: 100%;
      padding-left: 20px;
      z-index: 99;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #f5f5f5;
      .priceNum {
        text-align: center;
        color: #000;
        font-size: 16px;
        flex: 1;
        .num {
        }
        .price {
          color: #ff6700;
        }
      }
      .cartHeight_cart {
        margin-right: 40px;
        cursor: pointer;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #ff6700;
        color: white;
        font-size: 16px;
        padding: 0 20px;
        a.router-link-exact-active.router-link-active {
          color: white;
        }
      }
    }
  }
}

.hotBox {
  padding-left: 16px;
  text-align: left;
  .hotImg {
    height: 44px;
    vertical-align: bottom;
  }
  .hotSpan {
    height: 44px;
    line-height: 44px;
    display: inline-block;
    font-size: 22px;
    font-weight: 600;
    font-family: "宋体", "STSong", "STXinwei", "STFangsong";
  }
}

.searchBox {
  text-align: right;
}

.dialogIMBox /deep/.el-dialog--center .el-dialog__body {
  text-align: initial;
  padding: 9px 0px 0px;
  height: 445px;
}

.dialogIMBox /deep/.el-dialog--center {
  text-align: center;
  position: absolute;
  right: 50px;
  bottom: 0px;
}

div#content-main-1 {
  height: inherit;
}

.el-header {
  padding: 0 0px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}

/* 
布局后续删除start
 */

.el-header,
.el-footer {
  /* background-color: #b3c0d1; */
  color: #333;
  text-align: center;
  /* line-height: 60px; */
  height: auto !important;
  padding: 0 0px;
}

.el-main {
  color: #333;
  padding: 0px;
  min-height: 500px;
}

/* 
布局后续删除end
 */

.index-con {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

.aside {
  width: 64px !important;
  height: 100%;
  background-color: #334157;
  margin: 0px;
}

.asideshow {
  width: 240px !important;
  height: 100%;
  background-color: #334157;
  margin: 0px;
}

.index-header,
.index-main {
  padding: 0px;
  border-left: 2px solid #333;
}

.userNameBox {
  .el-image.userNameImg {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    border: 1px solid #dadada;
  }
  .userNameBoxText.el-col.el-col-14 {
    position: relative;
    transform: translate(0, 50%);
    line-height: 30px;
    font-size: 16px;
  }
}

.userNameBoxBottom.el-col.el-col-12 {
  text-align: center;
  margin-bottom: 10px;
  a {
    display: inline-block;
    padding: 5px 20px;
    background: #f7f7f7;
    border: 1px solid #cecece;
    border-radius: 4px;
  }
}

.fixedRightNav {
  .rightNav {
    width: 40px;
    height: 100%;
    position: fixed;
    background: #444851;
    z-index: 2;
    top: 0;
    right: 0;
    color: white;
    padding-top: 15%;
    box-sizing: border-box;
    text-align: center;
    z-index: 9999;
    .el-button {
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      background: transparent;
      border: 0px solid transparent;
      color: #606266;
      -webkit-appearance: none;
      text-align: center;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      outline: 0;
      margin: 0;
      -webkit-transition: 0.1s;
      transition: 0.1s;
      font-weight: 500;
      padding: 0;
      font-size: 14px;
      border-radius: 0px;
      width: 100%;
    }
    p.el-icon-user {
      font-size: 26px;
      display: block;
      height: 40px;
      line-height: 40px;
      color: #d9dada;
    }
    p.el-icon-user:hover {
      background: #ff6700;
      cursor: pointer;
    }
    .shoppingCart:hover {
      background: #ff6700;
      cursor: pointer;
    }
    .shoppingCart {
      margin: 20px 0;
      padding: 20px 0;
      i.el-icon-shopping-cart-2 {
        font-size: 26px;
        color: #d9dada;
      }

      p,
      .cartNum {
        font-size: 16px;
        padding: 0 10px;
        color: #d9dada;
        span {
          display: inline-block;
          width: 24px;
          background: #ff6700;
          border-radius: 10px;
        }
      }
    }
    .el-icon-view {
      font-size: 25px;
      display: block;
      height: 40px;
      line-height: 40px;
      color: #d9dada;
    }
    .el-icon-view:hover {
      background: #ff6700;
      cursor: pointer;
    }
    .nolike {
      width: 100%;
      height: auto;
      margin: 6px 0;
      padding: 8px 0;
      img {
        width: 70%;
      }
    }
    .nolike:hover {
      background: #ff6700;
      cursor: pointer;
    }
    .userPart {
      bottom: 50px;
      position: absolute;
      padding: 4px;
      left: 0px;
      .el-image {
        border-radius: 50%;
        width: 30px;
        height: 30px;
        i.el-icon-user {
          width: 30px;
          height: 30px;
          font-size: 30px;
        }
      }
    } // 回到顶部
    .el-backtop {
      background: transparent;
      color: white;
      i.el-icon-upload2 {
        font-size: 25px;
      }
    }
    .el-backtop:hover {
      background: #ff6700;
      border-radius: 0;
    }
  }
  .drawerCart {
    /deep/ :focus {
      outline: 0;
    }
    /deep/.el-drawer.rtl {
      padding-right: 50px;
      padding-left: 20px;
      background: #eceaea;
      /deep/.el-drawer__header {
        padding: 15px 0px;
        margin-bottom: 0;
      }
    }
    .drawerCartTitle {
      font-size: 17px;
      color: #5e5050;
      i.el-icon-shopping-cart-2 {
        font-size: 22px;
        vertical-align: middle;
      }
    }
    .drawerCartItem {
      // height: 900px;
      overflow: auto;
      padding-bottom: 50px;
      .drawerCartItem_no {
        text-align: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 16px;
        .gotoShopText {
          color: #ff6700;
        }
      }
    }
    .drawerFooterItem {
      display: flex; // justify-content: space-between;
      flex-wrap: wrap;
      .isdrawerFooterItem {
        .isdrawerFooterItemBg {
          background: white;
          padding: 8px;
          box-sizing: border-box;
          border-radius: 6px;
          margin-bottom: 15px;
          margin-right: 15px;
          .goodsFooter {
            width: 120px;
            height: 120px;
            background: #f5f5f5;
            cursor: pointer;
            position: relative;
            /deep/.image-slot {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
          .cartHeight {
            text-align: center;
            font-size: 16px;
          }
        }
      }
    }

    /* 购物车的样式 */
    .cartTip {
      height: 80vh;
      overflow-y: scroll;
      .cartBox.el-row {
        margin: 15px;
        background: white;
        width: 100%;
        padding: 10px;
        .el-image.cartgoodsPhotos {
          height: 80px;
          width: 100%;
          position: inherit;
          cursor: pointer;
        }
        .cartHeight {
          height: 80px;
          line-height: 80px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
        }
      }
      .cartHeight_total {
        font-size: 18px;
        padding: 0 20px;
        color: #ff6700;
        .totalNum {
          font-size: 14px;
          color: #000;
        }
      }
      .cartHeight_cart {
        cursor: pointer;
        height: 40px;
        text-align: center;
        line-height: 40px;
        background: #ff6700;
        color: white;
        font-size: 15px;
        a.router-link-exact-active.router-link-active {
          color: white;
        }
      }
    }
  }
}

.userPartPop {
  display: flex;
  justify-content: space-evenly;
  /deep/.el-image.userPartPop_img {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    i.el-icon-user {
      font-size: 30px;
    }
  }
  /deep/.userPartPop_text {
    line-height: 40px;
  }
}

/deep/.el-popover.el-popper.nolikePopBox {
  background: #5b5f67;
  color: white;
}

/deep/ .logo img {
  width: 255px;
  height: 52px;
}

.logotop {
  margin: 1rem 0;
}

.el-input-group__append {
  border-left: 0;
  background-color: #e13c41;
}

.el-input-group__append,
.el-input-group__prepend {
  background-color: #e13c41;
  color: white;
  vertical-align: middle;
  display: table-cell;
  position: relative;
  border: 0px;
  border-radius: 4px;
  padding: 0 20px;
  width: 1px;
  white-space: nowrap;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

/* 购物车样式 */

.el-button.btnBg:focus {
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
}

.el-button.btnBg:hover {
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
}

.el-button.shopgoods {
  height: 44px;
  border: 1px solid #e13c41;
  color: #e13c41;
  background: #fff;
  &:focus {
    background: #fff;
    color: #e13c41;
    border-color: #e13c41;
  }
}

/* top菜单 */

.categorys {
  float: left;
  width: 232px;
  height: 40px;
  position: relative;
}

.categorys-type {
  background-color: #f42424;
  text-align: center;
  font-size: 0;
  line-height: 40px;
}

.categorys-type a {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  display: block;
}

.nav-main {
  float: left;
  width: 968px;
  overflow: hidden;
  height: 40px;
  line-height: 40px;
}

.el-menu--horizontal > .el-menu-item {
  float: left;
  height: 40px;
  line-height: 40px;
  margin: 0;
  border-bottom: 2px solid transparent;
  color: #909399;
}

/deep/.el-menu--horizontal > .el-menu-item.is-active {
  color: #ff6700 !important;
  font-weight: bold;
}

/* 分类表 */

.categorys-tab-content {
  min-height: 500px;
  height: auto !important;
  padding: 15px 0;
  box-sizing: border-box;
  z-index: 30;
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.6);
  /* bingo */
  display: block;
  position: relative;
}

.categorys-tab-content .categorys-items {
  position: relative;
  height: 100%;
}

.categorys-tab-content .categorys-item {
  cursor: pointer;
  height: 14.29%;
}

.categorys-tab-content .item-content {
  padding: 6px 16px;
  float: left;
  width: 200px;
  display: flex;
  &:hover {
    background: #f42424;
    color: #fff;
  }
}

.categorys-tab-content .item-content .icon-other {
  float: left;
  width: 18px;
  height: 18px;
}

.categorys-tab-content .item-content .icon-other img {
  width: 100%;
}

.categorys-tab-content .selected .item-content {
  background-color: rgba(0, 0, 0, 1);
}

.categorys-tab-content .iconfont {
  float: left;
  color: #bfbfbf;
}

.categorys-tab-content .categorys-title {
  float: left;
  margin-left: 10px;
  text-align: left;
}

.categorys-tab-content .categorys-title strong {
  display: block;
  font-weight: normal;
}

.categorys-tab-content .categorys-title strong a {
  color: #fff;
  font-size: 14px;
}

.categorys-tab-content .categorys-title span {
  display: block;
  font-size: 0;
}

.categorys-tab-content .categorys-title span a {
  color: #bfbfbf;
  margin-right: 10px;
  font-size: 14px;
}

.categorys-tab-content .categorys-title span a:hover,
.categorys-tab-content .categorys-title strong a:hover {
  color: #fff;
}

.categorys-items-layer {
  display: none;
  position: absolute;
  top: 0;
  left: 232px;
  width: 966px;
  min-height: 498px;
  border: 1px solid #fff;
  background-color: #fff;
  box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, 0.1);
  -webkit-transition: top 0.25s ease;
  transition: top 0.25s ease;
  .nodataCss {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 14px;
  }
  .cate-layer-second {
    display: flex;
    flex-flow: wrap;
    .cateChanneSecond {
      margin: 10px;
      /deep/.el-image {
        width: 80px !important;
        height: 80px !important;
      }
      .cateChanneSecondName {
        display: block;
      }
    }
  }
}

.categorys-items-second-layer {
  min-height: 500px;
}

/* 购物车的样式 */

.cartTip {
  .cartBox.el-row {
    margin: 15px; // background: red;
    height: 80px;
    .el-image.cartgoodsPhotos {
      height: 80px;
      width: 100%;
      position: inherit;
    }
    .cartHeight {
      height: 80px;
      line-height: 80px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .cartHeight_total {
    font-size: 18px;
    padding: 0 20px;
    color: #ff6700;
    .totalNum {
      font-size: 14px;
      color: #000;
    }
  }
  .cartHeight_cart {
    cursor: pointer;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background: #ff6700;
    color: white;
    font-size: 15px;
    a.router-link-exact-active.router-link-active {
      color: white;
    }
  }
}

.input-with-select {
  border: none; // overflow: hidden;
  /deep/.el-input__inner {
    border: none;
    height: 36px;
  }
  .el-input-group__append {
    border: 1px solid;
    height: 40px;
    #seekBtn {
      width: 78px;
      height: 40px;
      background-color: #ea0a2a;
      box-sizing: border-box;
      margin-right: -22px;
      border-radius: 0; // margin-top: -4px;
      /deep/.el-icon-search {
        color: #fff;
        position: relative;
        top: -4px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/index.vue